export class GeographicalAddresses{
    "additionalInformation": string
      "deliveryPoint": string
      "identifier": string
      "extension": string
      "postalCode": string
      "coordinates": string
      "locality": string
      "wayNumber": string
      "cityId": string
      "countryId": string
      "rowId": string
      "streetName": string
      "cityName": string
      "countryCode": string
      "wayLabel": string
      "countryName": string
      "territorialDivision": string
}

export class GeographicalAddressesList {
    "geographical-addresses": GeographicalAddresses[]
}

export class GeolocationCoordinatesAddresses{
    "identifier": string
    "latitude": string
    "coordinates": string
    "rowId": string
    "longitude": string
}

export class GeolocationCoordinatesAddressesList {
    "geolocation-coordinates-addresses": GeolocationCoordinatesAddresses[]
}

export class PostalAddresses{
    "line7": string
    "identifier": string
    "line6": string
    "line5": string
    "line4": string
    "line3": string
    "line2": string
    "line1": string
    "rowId": string
}

export class PostalAddressesList {
    "postal-addresses": PostalAddresses[]
}
